import { request } from "@/utils/request";

/**
 * 操作退款
 * @param {*} data
 * @returns
 */
export function refund(data) {
  return request({
    url: `/refund/create`,
    method: "POST",
    data,
  });
}
